// apps/web/src/hooks/useEscapeKey.ts
//
// Calls `onEscape` when the Escape key is pressed, while `active` is true.
// The handler is kept in a ref (latest-value pattern) so callers can pass an
// inline or frequently-recreated callback without re-binding the listener on
// every render.

import { useEffect, useRef } from 'react';

export function useEscapeKey(
	onEscape: () => void,
	active: boolean = true,
): void {
	const cb = useRef<() => void>(onEscape);
	cb.current = onEscape;

	useEffect(() => {
		if (!active) return;
		const onKey = (e: KeyboardEvent): void => {
			if (e.key === 'Escape') cb.current();
		};
		window.addEventListener('keydown', onKey);
		return () => window.removeEventListener('keydown', onKey);
	}, [active]);
}
